import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticColorMetaConfigMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.log
   * */

  _getAdsListSemanticConfigKey = ({make, model}) => {
    const hasMake = Boolean(make)
    const hasModel = Boolean(model)

    const isDefault = !hasMake && !hasModel
    const isMake = hasMake || hasModel

    switch (true) {
      case isDefault:
        return 'default'
      case isMake:
        return 'make'
      default:
        return 'default'
    }
  }

  map = ({adsListSemanticConfig, params: {make, model}}) => {
    const adsListSemanticConfigKey = this._getAdsListSemanticConfigKey({
      make,
      model
    })

    return adsListSemanticConfig[adsListSemanticConfigKey] || adsListSemanticConfig.default
  }
}
